import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import api, { fileUrl, formatApiErrorDetail } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { UI } from "@/i18n";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { t, content } = useSite();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain min-h-screen bg-brand-navy flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={fileUrl(content?.logo_url)} alt="CT Upholstery" className="h-20 w-auto mx-auto rounded-lg border border-white/10" />
          <h1 className="mt-6 font-display uppercase text-3xl">{t(UI.admin.login)}</h1>
        </div>
        <form onSubmit={submit} className="rounded-xl border border-white/10 bg-brand-surface p-8 space-y-5">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t(UI.admin.email)}
            data-testid="admin-login-email"
            className="w-full bg-white/5 border border-white/15 rounded-lg px-4 py-3.5 text-sm placeholder:text-white/40 focus:outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/30"
          />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t(UI.admin.password)}
            data-testid="admin-login-password"
            className="w-full bg-white/5 border border-white/15 rounded-lg px-4 py-3.5 text-sm placeholder:text-white/40 focus:outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/30"
          />
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-brand-red bg-brand-red/10 border border-brand-red/30 rounded-lg px-4 py-3">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-brand-blue hover:bg-brand-cobalt disabled:opacity-60 font-bold py-3.5 rounded-lg transition-all"
          >
            <LogIn size={16} /> {busy ? t(UI.admin.signing) : t(UI.admin.enter)}
          </button>
        </form>
        <Link to="/" data-testid="admin-back-home" className="mt-6 flex items-center justify-center gap-2 text-sm text-white/50 hover:text-white transition-colors">
          <ArrowLeft size={15} /> ctupholstery.com
        </Link>
      </div>
    </div>
  );
}
